import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useTaxResidence = () => {
    const [taxResidenceDefault, setTaxResidenceDefault] = useState(null);
    const complementaryDataselectorsRequest = useSelector(
        (state) => state.environment.complementaryDataSelectorsRequest,
    );

    const {
        status: complementaryDataSelectorsStatus,
        value: complementaryDataSelectorsValue,
    } = complementaryDataselectorsRequest;

    useEffect(() => {
        if (complementaryDataSelectorsStatus === "SUCCESS") {
            const { legalAddress } = complementaryDataSelectorsValue;

            const taxResidence = {
                country: legalAddress?.paisResidencia || "-",
                province: legalAddress?.provincia || "-",
                locality: legalAddress?.localidad || "-",
                address: legalAddress?.domicilioPersonal?.calle || "-",
                postalCode: legalAddress?.domicilioPersonal?.codigoPostal || "-",
            };

            setTaxResidenceDefault(taxResidence);
        }
    }, [complementaryDataSelectorsStatus, complementaryDataSelectorsValue]);

    return { taxResidenceDefault };
};

export default useTaxResidence;
